import { render, staticRenderFns } from "./organization-structure.vue?vue&type=template&id=19ab9678"
import script from "./organization-structure.vue?vue&type=script&lang=js"
export * from "./organization-structure.vue?vue&type=script&lang=js"
import style0 from "./organization-structure.vue?vue&type=style&index=0&id=19ab9678&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports